<header-row [userName]="'Victoria Brown'" [userRole]="'REGIONAL MANAGER'"></header-row>

<div class="hospital-dashboard page-layout" *ngIf="dashboard && !isLoading; else loading">
  <div class="workspace-header">
    <div class="title-block">
      <div class="back" (click)="locationBack()" title="Back">
        <span class="material-icons">arrow_back</span>
      </div>
      <p-dropdown
        [options]="hospitalList"
        [(ngModel)]="selectedHospitalId"
        (ngModelChange)="onHospitalChange()"
        optionLabel="practiceName"
        optionValue="practiceSKey"
        [filter]="true"
        filterBy="practiceName"
        placeholder="Select hospital"
        styleClass="hospital-select"
      ></p-dropdown>
    </div>
    <div class="header-controls">
      <p-dropdown
        [options]="quarters"
        [(ngModel)]="selectedQuarter"
        (ngModelChange)="onQuarterChange()"
        optionLabel="quarterName"
        optionValue="quarterName"
        [filter]="true"
        filterBy="quarterName"
        placeholder="Select quarter"
        styleClass="quarter-select"
      ></p-dropdown>
      <button
        type="button"
        class="view-as-hm-toggle"
        *ngIf="canPreviewAsHM"
        [class.active]="previewAsHM"
        [attr.aria-pressed]="previewAsHM"
        (click)="togglePreviewAsHM()"
        [title]="previewAsHM ? 'Exit the Hospital Manager preview' : 'Preview the dashboard as a Hospital Manager'">
        <span class="material-icons">visibility</span>
        <span>{{ previewAsHM ? 'Exit HM View' : 'View as HM' }}</span>
      </button>
    </div>
  </div>

  <div class="hm-preview-banner" *ngIf="previewAsHM">
    <span class="material-icons">visibility</span>
    <span class="message">You are previewing the Hospital Manager view. Only goals published to HM and HM-visible notes are shown.</span>
    <button type="button" (click)="togglePreviewAsHM()">Exit preview</button>
  </div>

  <!-- ============ ZONE 1 : ATTENTION + TASKS / MEETINGS ============ -->
  <div class="grid-top">
    <vc-hospital-attention-card
      [eyebrow]="dashboard.hospitalName + ' · ' + dashboard.quarter + ' · ' + dashboard.weeksRemaining + ' weeks left'"
      [headline]="attentionHeadline"
      [sub]="'Everything else is tracking. Start here.'"
      [attention]="dashboard.attention"
      [stats]="dashboard.stats"
      [refreshedAt]="dashboard.refreshedAt"
      [isClear]="!dashboard.attention.length"
      [hasGoals]="dashboard.goals && dashboard.goals.length > 0"
      (openGoal)="focusGoal($event)"
      (openTasks)="scrollToTasks()"
    ></vc-hospital-attention-card>

    <div class="right-col">
      <vc-hospital-meetings-card
        [nextMeeting]="dashboard.nextMeeting"
        [upcomingMeetings]="dashboard.upcomingMeetings"
        [isLoading]="isLoading"
        [readOnly]="previewAsHM"
        (addMeeting)="addMeeting()"
        (joinMeeting)="joinMeeting($event)"
        (viewMeeting)="openMeetingDetailDialog($event)"
      ></vc-hospital-meetings-card>

      <vc-hospital-tasks-card
        id="hospital-tasks-card"
        [pastDueTasks]="dashboard.pastDueTasks"
        [upcomingTasks]="dashboard.upcomingTasks"
        [isLoading]="isLoading"
        [readOnly]="previewAsHM"
        (addTask)="addTask()"
        (viewAll)="viewAllTasks()"
        (openTask)="openTask($event)"
        (taskToggled)="completeTask($event)"
      ></vc-hospital-tasks-card>
    </div>
  </div>

  <!-- Hospital notes: HM sees only notes flagged visible to HM -->
  <vc-hospital-notes-card [hospitalId]="selectedHospitalId" [isHM]="isHM" [showHmToggle]="!isHM" [readOnly]="previewAsHM" [currentUserName]="currentUserName" [currentUserId]="currentUserId"></vc-hospital-notes-card>

  <!-- ============ ZONE 2 : THIS QUARTER'S GOALS ============ -->
  <div class="sec-title" *ngIf="dashboard.goals && dashboard.goals.length">This Quarter's Goals ({{ dashboard.quarter }})</div>
  <div class="goals-list" *ngIf="dashboard.goals && dashboard.goals.length">
    <vc-hospital-goal-card
      *ngFor="let goal of dashboard.goals"
      [id]="'hospital-goal-' + goal.goalTargetId"
      [goal]="goal"
      [isOpen]="expandedGoalTargetIds.has(goal.goalTargetId)"
      [autoFocus]="highlightedGoalTargetIds.has(goal.goalTargetId)"
      [isHM]="isHM"
      [readOnly]="previewAsHM"
      [currentUserName]="currentUserName"
      (toggle)="toggleGoal(goal.goalTargetId)"
      (addTask)="addGoalTask($event)"
      (openTask)="openTask($event)"
      (taskToggled)="completeTask($event)"
      (postNote)="onPostNote($event)"
      (updateNote)="onUpdateNote($event)"
      (deleteNote)="onDeleteNote($event)"
    ></vc-hospital-goal-card>
  </div>

  <!-- ============ ZONE 3 : NEXT QUARTER'S GOALS ============ -->
  <!-- <div class="sec-title">Next Quarter's Goals (4Q26)</div>
  <vc-hospital-next-quarter-goals
    [goals]="dashboard.nextQuarterGoals"
    [note]="'Only goals in Assigned status that have been reviewed with you are shown. Targets are subject to change before the quarter starts, so no progress is displayed.'"
  ></vc-hospital-next-quarter-goals>

  <div class="footer">LTK &mdash; Hospital Manager Dashboard</div> -->
</div>
<ng-template #loading>
  <div
    *ngIf="isLoading"
    style="
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(255, 255, 255, 0.95);
        z-index: 9999;
    ">
    <div style="text-align: center">
        <img
          src="/assets/catSpinner.gif"
          style="width: 130px; margin-bottom: 20px" />
        <div style="color: #363636; font-size: 24px">Please wait...</div>
    </div>
  </div>
</ng-template>
